import React from 'react';
import { TextField } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	helperText: {
		'&.MuiFormHelperText-root.Mui-error': {
			position: 'relative',
			bottom: '0',
		},
	},
}));

const Input = ({
	id,
	label,
	type = 'text',
	value,
	error,
	required = true,
	disabled,
	onChangeBlur,
	autoComplete = 'off'
}) => {
	const classes = useStyles();

	const inputProps = {
		required: required,
		fullWidth: true,
		disabled: disabled,
		id: id,
		type: type,
		label: label,
		value: value,
		variant: 'filled',
		error: !!error,
		helperText: error,
		autoComplete: autoComplete,
		onChange: (event) => onChangeBlur(event, type),
		onBlur: (event) => onChangeBlur(event, type),
		FormHelperTextProps: {
			className: classes.helperText,
		},
	};

	const multiLineProps = {
		...inputProps,
		multiline: true,
		rows: 5,
	};

	const inputNumberProps = {
		...inputProps,
		InputProps: {
			inputProps: { min: 1 },
		},
		onKeyPress: (event) => {
			if (event?.key === '-' || event?.key === '+') {
				event.preventDefault();
			}
		},
	};

	switch (type) {
		case 'multi':
			return <TextField {...multiLineProps} />;
		case 'number':
			return <TextField {...inputNumberProps} />;
		default:
			return <TextField {...inputProps} />;
	}
};

export default Input;
